'use client';

import { useTranslation } from 'react-i18next';

import { FabricaLogo } from '@/components/layout/FabricaLogo';
import { useContaAtiva } from '@/domain/auth/hooks/useContaAtiva';

/**
 * What the header says the system is: the product plus the account using it, the one picked in
 * the unified login (its name and logo are registered in the uMode dashboard). The uMode mark it
 * replaces does not disappear, it becomes the small "by uMode" underneath, because the platform
 * is still whose login and whose shell this is.
 *
 * While the account is not known the header shows the product alone, never an invented name.
 */
export function ShellBrand() {
  const { t } = useTranslation('common');
  const conta = useContaAtiva();

  const titulo =
    conta.nome === ''
      ? t('produto.nome')
      : t('produto.comFabrica', { produto: t('produto.nome'), fabrica: conta.nome });

  return (
    <div className="flex min-w-0 items-center gap-2">
      {conta.nome !== '' && <FabricaLogo conta={conta} size="sm" />}
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="truncate text-sm font-semibold text-foreground">{titulo}</span>
        <span className="truncate text-[0.625rem] text-foreground-faint">{t('produto.porUmode')}</span>
      </span>
    </div>
  );
}
